var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('AppHeader'),_c('HeroSection'),_c('ProductsSection'),_c('TechSection'),_c('PartnershipSection'),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }